import type { AdminTicketDetailsDto } from "@/api/types";
import { formatDate } from "@/components/FormattedDate/FormattedDate";
import { ClockIcon } from "@/components/Icons/ClockIcon";
import { TicketReminderModal } from "@/components/Ticket/TicketReminderModal";
import { Button } from "@/design-system/Button";
import { useBool } from "@/hooks/useBool";
import { useTranslation } from "@/translations";

export function TicketReminderButton({ ticket }: { ticket: AdminTicketDetailsDto }): React.ReactNode {
  const [isReminderModalOpened, reminderModalOpenHandlers] = useBool(false);
  const { i18n, t } = useTranslation();
  if (!ticket.canSetReminder) {
    return null;
  }

  return (
    <>
      {!ticket.remindAt ? (
        <Button
          variant="soft"
          onClick={reminderModalOpenHandlers.setTrue}
          title={t("page.tickets.details.remind-me-later.tooltip")}
          icon={<ClockIcon />}
          data-testid="ticket-reminder-btn"
        >
          {t("page.tickets.details.remind-me-later.create")}
        </Button>
      ) : (
        <Button
          variant="filled"
          onClick={reminderModalOpenHandlers.setTrue}
          title={t("page.tickets.details.remind-me-later.tooltip")}
          icon={<ClockIcon />}
          data-testid="ticket-reminder-update-btn"
        >
          {t("page.tickets.details.remind-me-later.edit", {
            when: formatDate(i18n, "datetimeShort", ticket.remindAt),
          })}
        </Button>
      )}
      <TicketReminderModal
        ticketId={ticket.id}
        isOpened={isReminderModalOpened}
        onOpenChange={reminderModalOpenHandlers.set}
        reminderDate={ticket.remindAt}
        daysToAutoClose={ticket.category.closeAfterInactiveDayAmount}
      />
    </>
  );
}
